'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BOOL_TRUE = require('permanent/es/BOOL_TRUE');

var _BOOL_TRUE2 = _interopRequireDefault(_BOOL_TRUE);

var _newArray2 = require('./_internal/_newArray');

var _newArray3 = _interopRequireDefault(_newArray2);

var _fill2 = require('./_internal/_fill');

var _fill3 = _interopRequireDefault(_fill2);

var _map2 = require('./_internal/_map');

var _map3 = _interopRequireDefault(_map2);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var internal = function internal(fn, len) {
    return (0, _map3.default)((0, _fill3.default)((0, _newArray3.default)(len), _BOOL_TRUE2.default), function (v, i) {
        return fn(i);
    });
}; /**
    * Return array of function iterations of specified length generated from 0-based index
    *
    * @module iterate
    * @func
    * @since 1.9.0
    * @param {function} fn
    * @param {number} len
    * @return {Array}
    * @example
    *
    *     const foo = index => index + 1;
    *     iterate(foo, 3); //=> [1, 2, 3]
    *     iterate(foo)(2); //=> [1, 2]
    */

var iterate = (0, _define2.default)(internal);

exports.default = iterate;